import { useTranslation } from 'react-i18next';

import { useUpdateBrand } from '~/api/user';
import { toast } from '~/utils/toast';

import type { EditBrandFormType, EditBrandModalProps as Props } from './types';

import { CreateEditBrandModal } from './CreateEditBrandModal';

export const EditBrandModal = ({ brand, onClose }: Props) => {
  const mutation = useUpdateBrand(brand.id);

  const { t } = useTranslation(['common', 'settings']);

  const onSubmit = (data: EditBrandFormType) => {
    return mutation.mutate(
      {
        companyName: data.companyName,
        email: data.email,
        color: data.color,
      },
      {
        onSuccess: () => {
          toast.success({ description: t('settings:alerts.brands.successUpdated') });
          onClose();
        },
        onError: () => {
          toast.danger({ description: t('common:error') });
        },
      },
    );
  };

  return <CreateEditBrandModal brand={brand} isLoading={mutation.isPending} onClose={onClose} onSubmit={onSubmit} />;
};
